/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InventoryCategoryVm
 */
export interface InventoryCategoryVm {
    /**
     * 
     * @type {string}
     * @memberof InventoryCategoryVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryCategoryVm
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryCategoryVm
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryCategoryVm
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryCategoryVm
     */
    isActive?: boolean;
}

export function InventoryCategoryVmFromJSON(json: any): InventoryCategoryVm {
    return InventoryCategoryVmFromJSONTyped(json, false);
}

export function InventoryCategoryVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): InventoryCategoryVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
    };
}

export function InventoryCategoryVmToJSON(value?: InventoryCategoryVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'value': value.value,
        'description': value.description,
        'isActive': value.isActive,
    };
}


